<template>
  <div class="pubdataset">
    <a-row :gutter="[12, 24]">
      <a-col
        :xs="{ span: 0 }"
        :sm="{ span: 0 }"
        :md="{ span: 0 }"
        :xl="{ span: 6 }"
        :lg="{ span: 6 }"
      >
        <a-affix :offset-top="100">
          <a-card size="small" title="Table of contents">
            <a
              @click="changeHash('#basic')"
              type="primary"
              style="margin-top: 20px; font-size: 17px"
              >1. Basic information
            </a>
            <br />
            <a
              @click="changeHash('#perturbationComp')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >2. Perturbation Composition
            </a>
            <br />
            <a
              @click="changeHash('#regularumap')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >3. UMAP for dimensionality reduction</a
            >
            <br />
            <a
              @click="changeHash('#gas')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >4.
              <!-- <a-icon type="fire" theme="twoTone" two-tone-color="#eb2f96" /> -->
              Differentially gene activity score</a
            >
            <!-- <br />
            <a
              @click="changeHash('#vnplotAnchor')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              5. Differential transcription factor motif</a
            > -->
          </a-card>
        </a-affix>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 18 }"
        :gutter="[16, 24]"
      >
        <a-row>
          <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }">
            <a-card
              size="small"
              id="basic"
              style="border-radius: 5px; border-color: #c9c9c9"
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a
                slot="title"
                style="font-size: 20px; color: black"
                class="guider"
              >
                Dataset Information
              </a>
              <a-descriptions bordered size="small">
                <a-descriptions-item label="Dataset ID">
                  <i style="font-weight: bolder; color: black">
                    {{ this.$route.query.datasetId }}</i
                  >
                </a-descriptions-item>
                <a-descriptions-item label="Cell line">
                  {{ this.cell }}
                </a-descriptions-item>
                <a-descriptions-item label="Sample type">
                  {{ this.sample }}
                </a-descriptions-item>
                <a-descriptions-item label="Title">
                  <span class="title">{{ this.title }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="Publication">
                  {{ this.periodicals }}
                </a-descriptions-item>
                <a-descriptions-item label="Year">
                  {{ this.time }}
                </a-descriptions-item>

                <a-descriptions-item label="Description">
                  <div style="text-align: justify">
                    {{ this.summary }}
                  </div>
                </a-descriptions-item>
              </a-descriptions>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
          >
            <a-card
              size="small"
              id="rank"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Perturbation Composition</a
              >
              <a-row :gutter="[12, 12]">
                <a-col :span="24"
                  ><a-card title="Total perturbations" size="small">
                    <pie /> </a-card
                ></a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
          >
            <a-card
              size="small"
              id="regularumap"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >UMAP for Dimensionality Reduction</a
              >
              <a-row :gutter="[12, 12]">
                <a-col :span="12"
                  ><a-card title="UMAP plot labled by cluster" size="small">
                    <umap /> </a-card
                ></a-col>
                <a-col :span="12"
                  ><a-card
                    title="UMAP plot labled by perturbed gene"
                    size="small"
                  >
                    <umapGene /> </a-card
                ></a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
          >
            <a-card
              size="small"
              id="gas"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Differentially Gene Activity Score</a
              >
              <gac />
            </a-card>
          </a-col>
          <!-- <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="cor"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <span slot="title" class="guider" style="color: black"
                >Differentially accessible chromatin region
                <a-tooltip title="Download total peaks.">
                  <a
                    :href="`http://research.gzsys.org.cn/perturbdb/data/scATACseq/${this.$route.query.datasetId}/peak.csv`"
                    style="color: blue; margin-left: 5px"
                    download
                  >
                    <a-icon type="cloud-download" />
                  </a>
                </a-tooltip>
              </span>
              <a-row>
                <a-col :span="24"> <dacr /> </a-col>
              </a-row>
            </a-card>
          </a-col>

          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="pc"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Differential transcription factor motif</a
              >
              <dtf />
            </a-card>
          </a-col> -->
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
import umap from "./subCom/umap_regular.vue";
import umapGene from "./subCom/umap.vue";
import pie from "./subCom/cellPie.vue";
import gac from "./subCom/gacPage.vue";
// import dacr from "./subCom/dacrPage.vue";
// import dtf from "./subCom/dtfPage.vue";

export default {
  components: {
    umap,
    umapGene,
    pie,
    gac,
    // dacr,
    // dtf,
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/scATAC/publications_basic.php",
        {
          params: { datasetId: this.$route.query.datasetId },
        }
      )
      .then((response) => {
        this.title = response.data[0]["title"];
        this.periodicals = response.data[0]["periodicals"];
        this.time = response.data[0]["time"];
        this.cell = response.data[0]["cell"];
        this.sample = response.data[0]["sample"];
        this.summary = response.data[0]["summary"];
      });
  },
  data() {
    return {
      //show
      marker: 0,
      showUmap: true,
      umpaspan: 10,
      tablespan: 14,
      title: null,
      periodicals: null,
      time: null,
      cell: null,
      sample: null,
      num: null,
      summary: null,
      clusters: 0,
      value: ["NT"],
      chooseGene: "",
      visible: false,
      //genelist:
      genelist: null,
      yaxis:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/customeGene.txt",
      //vnplot
      vnplotlinks: null,
      vnplot_visible: true,
      //color #不得行
      color: "#FF0000",
      isShowColors: false,
      color2: "#0000FF",
      isShowColors2: false,
      //other params
      doLog: 0,
      doNP: 0,
      //corMatrix
      corMatrix:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/corMatrix.txt",
    };
  },
  watch: {
    value(val) {
      console.log(`selected:`, val);
    },
    // chooseGene(val) {
    //   console.log(`selected:`, val);
    //   if (this.chooseGene.length > 1) {
    //     this.$message.warning(
    //       "Please choose one gene! This will disappear in 3 seconds.",
    //       3
    //     );
    //     this.chooseGene = [];
    //   }
    // },
  },
  methods: {
    gotoSeurat() {
      let href = "https://satijalab.org/seurat/reference/averageexpression";

      window.open(href, "_blank");
    },
    // 颜色输入框点击事件处理1
    colorInputClick() {
      this.isShowColors = !this.isShowColors;
    },
    colorInputOut() {
      this.isShowColors = !this.isShowColors;
    },
    // 颜色值改变事件处理
    colorValueChange(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color = val.hex;
    },
    // 颜色输入框点击事件处理2
    colorInputClick2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    colorInputOut2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    // 颜色值改变事件处理
    colorValueChange2(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color2 = val.hex;
    },
    //改变other option
    changeLog(e) {
      //this.$message.success(e.target.value);
      console.log(e.target.value);
    },
    changeNP(e) {
      //this.$message.success(e.target.value);
      console.log(e.target.value);
    },
    vnplot() {
      this.visible = true;
      this.vnplot_visible = true;
      this.vnplotlinks = null;
      // console.log(this.$route.query.datasetId);
      // console.log(String(this.value));
      // console.log(String(this.chooseGene));
      ///console.log(String(this.color).split("#")[1]);
      //console.log(String(this.color2).split("#")[1]);
      // console.log(String(this.doLog));
      // console.log(String(this.doNP));
      axios
        .get("http://research.gzsys.org.cn/perturbdb/API/plot/01vnplot.php", {
          params: {
            datasetId: this.$route.query.datasetId,
            value: String(this.value),
            choosegene: String(this.chooseGene),
            color1: String(this.color).split("#")[1],
            color2: String(this.color2).split("#")[1],
            dolog: this.doLog,
            doNP: this.doNP,
          },
        })
        .then((response) => {
          if (response.data != "failed") {
            this.vnplot_visible = false;
            this.$message.success(response.data + ".pdf plotted!", 6);
            this.vnplotlinks =
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
              response.data +
              ".pdf#zoom=60";
          } else {
            this.visible = false;
            this.vnplot_visible = false;
            this.vnplotlinks = null;
            this.$message.error(
              "Please check step2, and input an valid gene!",
              6
            );
          }
        });
    },
    changeHash(idname) {
      document.querySelector(idname).scrollIntoView({
        behavior: "smooth",
        // block: "start",
        // inline: "nearest",
      });
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.title {
  font-weight: bolder;
  color: black;
}
.guider {
  font-weight: bolder;
  font-size: 20px;
}
</style>
